import { getFormat, separatebycomma } from "@/libs/utils/formats";

// ─── Networks ─────────────────────────────────────────────────────────────────

export function getNetworksUsedInProposals(proposals) {
  if (!proposals || proposals.length === 0) return ['instagram'];
  return [...new Set(proposals.map(p => p.user_network?.network).filter(Boolean))];
}

// ─── State ───────────────────────────────────────────────────────────────────

export function isYourProposal(user, proposal) {
  if (user) return proposal?.user_network?.user === user.id;
  return false;
}

export function getVanityNameFromService(chat) {
  return chat?.creator?.vanity_name || null;
}

// ─── Permissions ─────────────────────────────────────────────────────────────

// agency permission temporary disabled 
export function agency_permission(user, proposal) {
  const has_agency_permission = user?.user_permissions?.some(item => item.codename === 'user_agency') || false;
  if (!has_agency_permission) return false;

  const proposal_agency_uuid = proposal?.agency?.uuid;
  if (!proposal_agency_uuid) return false;

  const same_agency = user?.user_agency?.some(agency => agency.uuid === proposal_agency_uuid);
  return !!same_agency;
}

export function isAvailableToEdit(user, proposal) {
  // return isYourProposal(user, proposal) || agency_permission(user, proposal);
  return isYourProposal(user, proposal) && proposal.state !== 'published';
}

export function canEditProposals(user) {
  if (!user) return false;
  if (user.is_superuser) return true;
  const has_permission_edit = user.user_permissions.find(per => per.codename === 'change_proposalsusernetwork');
  return !!has_permission_edit;
}

// ─── Pricing ─────────────────────────────────────────────────────────────────

export function getTotal(checked_options, deal_selected) {
  let total = 0;
  checked_options.forEach((option) => {
    total += parseFloat(option.price);
  });
  return total + parseFloat(deal_selected.price);
}

export function getPriceProposals(deal) {
  let total = 0;
  if (!deal) return '$ 0 USD';
  if (deal.is_brandme_talent) return "$".repeat(deal.range_price);

  total = deal.price || 0;

  return `$ ${separatebycomma(total)} USD`;
}

export function getTotalInfluencers(deals) {
  let total = 0;
  Object.entries(deals).forEach(([, value]) => {
    total += value;
  });
  return getFormat(total); 
}

export function isDiscountValid(balance_discount, getBalance, checked_options, deal_selected) {
  return (
    balance_discount >= 1 &&
    balance_discount <= getBalance &&
    balance_discount <= getTotal(checked_options, deal_selected)
  );
}

export function optionsHasBrandmeTalent(checked_options) {
  return checked_options.some(op => op.is_brandme_talent);
}

// ─── Discount ─────────────────────────────────────────────────────────────────

export function applyBalanceDiscount(balance_discount, checked_options, deal_selected) {
  const total = getTotal(checked_options, deal_selected);
  return total - balance_discount;
}

export function validateOnlyNumbers(event) {
  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
}
